export default {"src":"/_next/static/media/facebook.b6bd443e.svg","height":24,"width":13};